<template>
  <a-flex justify="center" align="center">
    <PopoverMenu
      class="popover-item"
      :main-button-text="label.attachedPrinterName"
      :disabled="isLabelUpdating"
      :loading="isLabelUpdating"
      @update:popoverIsOpen="popoverIsOpen = $event"
      v-model:popover-is-open="popoverIsOpen"
    >
      <a-flex vertical gap="small">
        <a-button
          v-for="(printer, index) in printers"
          :key="index"
          class="printer"
          @click="onPrinterSelected(printer.value)"
          type="text"
          size="small"
          :disabled="printer.label === label.attachedPrinterName"
        >
          {{ printer.label }}
        </a-button>
      </a-flex>
    </PopoverMenu>
  </a-flex>
</template>

<script setup lang="ts">
import PopoverMenu from "@/components/UI/PopoverMenu.vue";
import {
  type LabelTemplateTableData,
  useLabelTemplateStore,
} from "@/stores/labelTemplate/labelTemplateStore";
import { computed, ref } from "vue";
import { useQzTrayStore } from "@/stores/qzTray/qzTrayStore";

const props = defineProps<{ label: LabelTemplateTableData }>();

const popoverIsOpen = ref<boolean>(false);

const qzTrayStore = useQzTrayStore();
const labelTemplateStore = useLabelTemplateStore();

const printers = computed(() => qzTrayStore.printersForSelect);
const isLabelUpdating = computed(() =>
  labelTemplateStore.processingPersonalLabels.has(props.label.label.id),
);

const onPrinterSelected = async (printer: string | null) => {
  await labelTemplateStore.updateLabelTemplatePrinter(
    props.label.label.id,
    printer,
  );

  popoverIsOpen.value = false;
};
</script>

<style scoped lang="scss">
.ant-btn {
  width: 100%;
  text-align: start;
}
</style>
